import axios from 'axios';
import { toast } from 'react-toastify';

const instance = axios.create({
  baseURL: 'http://localhost:5000', // change your API base URL here
});

// Attach token automatically
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiry globally
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.data?.message?.includes('jwt expired')) {
      toast.error("Session expired. Please log in again.");
      localStorage.removeItem('token');
      window.location.href = '/LoginPage'; // force redirect
    }
    return Promise.reject(error);
  }
);

export default instance;
